/* global register_user_ajax_url, translationsEmail */
export default {
  init() {
    checkEmail();
  },
  finalize() {
    // JavaScript to be fired on the checkout page, after the init JS
  },
};

export var checkEmail = () => {
  $('button[name="start_registration"]').on('click', function(e) {
    let email = $('#email').val();
    $('.error-message').remove();
    e.preventDefault();
    // eslint-disable-next-line no-useless-escape
    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (regex.test(email))
    {
      $.ajax({
        type: 'POST'
        , dataType: 'json'
        , url: register_user_ajax_url.ajax_url
        , data: {
          'email': email,
        }
        , success: function (response) {
          if(response.success) {
            $(e.target).closest('form')[0].submit();
          }else {
            //message tonen
            $('<p class="error-message">' + response.data + '</p>').insertBefore($('.woocommerce-form-register__submit'));
          }
        },
      });
    }else{
      $('<p class="error-message">' + translationsEmail.invalid_email + '</p>').insertBefore($('.woocommerce-form-register__submit'));
    }
  });
}
